<template>
  <el-popover
    placement="top"
    width="190"
    trigger="click"
    v-model="showDurationPopover">
    <div v-if="showDurationPopover">
      <div style="display: flex; flex-wrap: wrap; flex-direction: row; justify-content: flex-start;">
        <el-button
          v-for="(value, text) in quickDurationSettings"
          :key="'quick-time-'+text"
          size="mini"
          type="text"
          class="mx-1 w-25"
          @click="onQuickSetDuration(value)">
          {{text}}
        </el-button>
      </div>
      <div style="display: flex; flex-wrap: nowrap">
        <!--<el-input-number v-model="durationInSeconds" type="number" size="mini" :min="0" style="width:65%" class="m-1" />-->
        <el-input
          v-show="!editTextActive"
          size="mini"
          v-model="durationInSeconds"
          @focus="onFocusTextDuration(value)"></el-input>
        <el-input
          v-show="editTextActive"
          size="mini"
          v-model="durationFixed"
          @keyup.enter.native="onSetDuration()"></el-input>
        <el-button size="mini" @click="onSetDuration()">ok</el-button>
      </div>
    </div>
    <span slot="reference" v-if="duration !== undefined " class="duration-quick-settings-text" >
      <slot v-if="showSeconds" v-bind:duration="duration" v-bind:value="value">
        <span>{{ value >= 0 ? this.$filters.hoursMinutesSeconds(value) : this.$filters.hoursMinutesSeconds(0)}}</span>
      </slot>
      <slot v-else v-bind:duration="duration" v-bind:value="value">
        <span>{{ value >= 0 ? this.$filters.hoursMinutes(value) : this.$filters.hoursMinutes(0)}}</span>
      </slot>
    </span>
  </el-popover>
</template>

<script>
import { mapGetters } from 'vuex'
import util from "@/util";
import clonedeep from 'lodash.clonedeep'

// TODO: vertical scroll should close menu

export default {
  props: {
    value: {
      /* seconds */
    },
    suffix: {
      default: ''
    },
    quickDurationSettings: {
      default: () => ({
        '0 min':  0 * 60,
        '2 min':  2 * 60,
        '5 min':  5 * 60,
        '10 min': 10 * 60,
        '15 min': 15 * 60,
        '30 min': 30 * 60,
        '60 min': 60 * 60,
        '2 h':    2 * 60 * 60,
        '3 h':    3 * 60 * 60,
        '8 h':    8 * 60 * 60,
        'custom': -1
      })
    },
    updateOnSave: {
      default: true
    },
    showSeconds: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    duration: 0,
    showDurationPopover: false,
    init_kanban_scroll_position: 0,
    editTextActive: false,
    durationFixed: 0
  }),
  created() {
    if (!isNaN(this.value)) {
      this.duration = clonedeep(this.value)
    }
  },
  mounted() {
    this.init_kanban_scroll_position = this.kanban_scroll_position;
  },
  computed: {
    ...mapGetters('app', ['kanban_scroll_position']),

    durationInSeconds: {
      get() {
        if (!this.editTextActive && this.duration) {
          if (this.showSeconds) {
            return this.$filters.hoursMinutesSeconds(this.duration)
          } else {
            return this.$filters.hoursMinutes(this.duration)
          }
        } else if (this.editTextActive) {
          return this.durationFixed
        } else {
          if (this.showSeconds) {
            return this.$filters.hoursMinutesSeconds(0)
          } else {
            return this.$filters.hoursMinutes(0)
          }
        }
      },
      set(value) {
        /*console.log('maker1')
        if (this.editTextActive) {
          let result = util.matchUserInputDuration('!' + value )
          console.log('durationInSeconds:', result)
          if (result.duration >= 0) {
            this.durationFixed = result.duration
          }
        }*/
      }
    },

    durationValue: {
      get() {
        return this.durationFixed
      },
      set() {

      }
    }
  },
  watch: {
    value(value) {
      this.duration = this.value;
    },
    duration(value) {
      if ( !this.updateOnSave ) {
        this.$emit('input', value);
      }
    },
    kanban_scroll_position(v) {
      if ( Math.abs( this.init_kanban_scroll_position - v ) > 30 ) {
        this.showDurationPopover = false;
      }
    }
  },
  methods: {

    onFocusTextDuration(value) {
      console.log('onFocusTextDuration')
      this.editTextActive = true
      this.durationFixed = clonedeep(this.$filters.hoursMinutesSeconds(this.duration)).toString()
      console.log(this.durationFixed)
    },

    onBlurTextDuration() {
      console.log('onBlurTextDuration')
      this.editTextActive = false
    },

    onQuickSetDuration(value) {
      this.showDurationPopover = false;
      if ( value < 0 ) {
        this.$emit('custom')
        return;
      }
      if ( this.updateOnSave ) {
        this.$emit('input', value);
      }
      this.$emit('save', value);
    },

    onSetDuration() {
      let result = util.matchUserInputDuration('!' + this.durationFixed )
      console.log('durationInSeconds:', result)
      let duration = 0
      if (result.duration >= 0) {
        duration = result.duration
      }
      this.showDurationPopover = false;
      if ( duration < 0 ) {
        this.$emit('custom')
        return;
      }

      if ( this.updateOnSave ) {
        this.$emit('input', duration);
      }
      this.$emit('save', duration);
      this.duration = duration
    },

    /*onSaveTextDuration(value) {

    }*/
  }
}
</script>

<style>
.duration-quick-settings-text:hover {
  text-decoration: underline;
  text-decoration-style: double;
  text-decoration-color: #409eff;
}
.duration-quick-settings-text {
  cursor: pointer;
}
</style>
